import type { ProductListViewModel } from 'autogen/swagger/all';
import ContentfulContext from '../Contentful/ContentfulContext';
import ContentfulPLP from '../Contentful/pages/ProductListPage';
import ProductListPage from './ProductListPage';

export default function RenderProductListPage({ model }: { model: ProductListViewModel }) {
    const { contentfulContent, contentfulSeoContentBlock } = model;

    if (contentfulContent || contentfulSeoContentBlock) {
        return (
            <ContentfulContext.Provider value={{ template: 'productListTemplate' }}>
                <ContentfulPLP model={model} />
            </ContentfulContext.Provider>
        );
    }

    return <ProductListPage model={model} />;
}
